import { ParticipantMode } from './boutique-classroom.constants';

export interface ClassroomStudent {
	id: number;
	fullName: string;
	avatarUrl?: string;
}

export interface ClassroomExpertMember {
	id: number;
	groupMemberId: number;
	fullName: string;
	avatarUrl?: string;
	branchId?: number;
	branchName?: string;
	liveServiceType?: string;
}

export interface ClassroomGroup {
	id: number;
	name: string;
	students: ClassroomStudent[];
	experts: ClassroomExpertMember[];
}

export interface EventTypeOption {
	id: number | typeof ALL_EVENT_TYPES_ID;
	name: string;
	colorClass?: string;
}

export interface ExpertEventType {
	id: number;
	code: string;
	name: string;
	isGroupEvent: boolean;
}

export interface AcademicBoardBranch {
	id: number;
	name: string;
}

export interface AcademicBoardExpert {
	id: number;
	fullName: string;
	avatarUrl?: string;
	branches: AcademicBoardBranch[];
}

export interface EventPlatformOption {
	id: string;
	name: string;
}

export const ALL_GROUPS_ID = 0 as const;
export const ALL_EVENT_TYPES_ID = 'ALL' as const;

export type ParticipantModeValue = (typeof ParticipantMode)[keyof typeof ParticipantMode];

export interface SelectItem {
	id: number | string;
	name: string;
}

export interface CreateEventFormValues {
	eventType: ExpertEventType | null;
	name: string;
	shortDescription: string;
	platform: EventPlatformOption | null;
	participationLink: string;
	branch: AcademicBoardBranch | null;
	expert: AcademicBoardExpert | null;
	date: Date | null;
	startTime: Date | null;
	endTime: Date | null;
	participantMode: ParticipantModeValue;
	groups: SelectItem[];
	studentIds: number[];
}

export interface StudentPickerItem {
	id: number;
	fullName: string;
	groupId: number | null;
	groupName: string;
	schoolName: string;
}

export interface CreateGroupFormValues {
	name: string;
	studentIds: number[];
}

export type CreateEventFormField = keyof CreateEventFormValues;
export type CreateEventFormErrors = Partial<Record<CreateEventFormField, string>>;

export interface PlannedLessonSlot {
	id: number;
	startTime: string;
	endTime: string;
}

export interface PlannedLessonDraft {
	branchId: number | null;
	lesson: SelectItem | null;
	unit: SelectItem | null;
	topic: SelectItem | null;
	expertId: number | null;
	date: string | null;
	slot: PlannedLessonSlot | null;
}

export interface PlannedLessonMessage {
	title: string;
	message: string;
}

export interface PlannedLessonItem {
	studentId: number;
	studentName: string;
	gradeId?: number;
	branchId: number;
	branchName: string;
	lessonId: number;
	lessonName: string;
	topicId: number;
	topicName: string;
	expertId: number;
	expertName: string;
	date: string;
	slot: PlannedLessonSlot;
}
